import { render, staticRenderFns } from "./CouponList.vue?vue&type=template&id=ab5ce380&scoped=true"
import script from "./CouponList.vue?vue&type=script&lang=js"
export * from "./CouponList.vue?vue&type=script&lang=js"
import style0 from "./CouponList.vue?vue&type=style&index=0&id=ab5ce380&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab5ce380",
  null
  
)

export default component.exports